<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-8">
<h1>Chapter 8</h1>
<p>Charlie groans as he and Dell make their way down the spiralling stairs. ‘My back is playing up again, I really need to do more stretching exercises. Bending down and crawling into cupboards is not as easy as it used to be.’ Charlie looks over at Dell who’s smiling with admiration. ‘What are you grinning about big fella?’</p>
<p>‘Audrey is a very nice girl,’ Dell says.</p>
<p>Charlie smiles at the thought; delighted that Dell and Audrey had a moment to bond. ‘Yes, she certainly is, Dell.’</p>
<p>As Dell continues down the stairs, Charlie falls behind, stopping midway, fixated with his thoughts. Dell is quick to notice and concerns himself. ‘Are you all right boss?’</p>
<p>Charlie looks at Dell before taking a seat on the steps. ‘Have a seat, Dell; I want to talk to you about something.’</p>
<p>Dell hauls his large frame back up the stairs and sits beside Charlie. Charlie ponders for a moment before addressing Dell in a sincere tone. ‘Dell, I want you to take good care of Audrey for me.’</p>
<p>Dell looks at Charlie, feeling confused at his request.</p>
<p>‘I won’t always be here Dell. I’m getting older by the day and now that you’re here helping me, well, one day soon you’ll be running this place.’ Charlie looks down momentarily before continuing. ‘Audrey is very special to me Dell. She’s like a daughter. A sweet, annoying and often stubborn one, but nevertheless, she’s like family to me. Do you understand what I’m telling you?’</p>
<p>Dell acknowledges Charlie’s attachment to Audrey. ‘Yes sir, I understand. I’ll take good care of her.’</p>
<p>Charlie smiles at Dell patting him once on his bicep.</p>
<p>‘I know you will.’ Charlie rises to his feet, letting out another small groan. ‘Come on big guy, let’s go have some lunch.’</p>
<p>Dell smiles at the thought of food. ‘Yes boss.’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?22250578